module.exports = __webpack_public_path__ + "img/sdg17.00b1aaca.svg";